export const apiUrl = process.env.AJAX_ROOT;

export const environment = process.env.NODE_ENV;



// WEBPACK FOOTER //
// ./src/config.js